module.exports = __webpack_public_path__ + "img/hr-green-pita-03.73602c01.png";